/**
 * filterEndColumnAge — Pure Function (PR 3, 01.06.).
 *
 * Default-aktiver Filter der in den End-Spalten (in_kontakt, positiv, negativ,
 * negativ_hotlead) nur Karten zeigt deren `enteredStatusAt` juenger als 90 Tage
 * ist. Ziel: das Board bleibt uebersichtlich, alte abgeschlossene Karten
 * verschwinden ohne dass jemand sie aktiv "archivieren" muss.
 *
 * Karten in den Pipeline-Spalten (lead_form, followup_1, followup_2) sind vom
 * Filter NICHT betroffen — die sollen immer sichtbar bleiben.
 *
 * Toggle "Alle anzeigen" deaktiviert den Filter (Pass-Through).
 */

import type { Lead } from '../types';
import { COLUMNS } from './columns';

export const END_COLUMN_AGE_DEFAULT_DAYS = 90;

export function filterEndColumnAge(
  leads: Lead[],
  enabled: boolean,
  now: Date,
  maxDays: number = END_COLUMN_AGE_DEFAULT_DAYS,
): Lead[] {
  if (!enabled) return leads;
  const cutoffMs = now.getTime() - maxDays * 24 * 60 * 60 * 1000;
  return leads.filter((lead) => {
    const col = COLUMNS.find((c) => c.status === lead.status);
    if (!col?.isEndColumn) return true; // Pipeline-Spalten passieren immer
    return new Date(lead.enteredStatusAt).getTime() >= cutoffMs;
  });
}
